<div class="progress">
  <div
    class="progress-bar"
    role="progressbar"
    [ngStyle]="{width: value + '%', backgroundColor: color}"
    aria-valuenow="0"
    aria-valuemin="0"
    aria-valuemax="100"
  ></div>
</div>
